export default "__VITE_ASSET__BdzeJzMZ__"